import { useTranslation as useReactI18nextTranslation } from 'react-i18next';

import type { Translate } from '../internationalization/translation';
import { useApplicationContext } from './use-application-context';

export const useTranslate = (): Translate => {
    const { translate } = useApplicationContext();

    return translate;
};

export const useTranslateFromNearestProvider = (): Translate => {
    const { t } = useReactI18nextTranslation();

    return (key, options) => String(t(key, { ...options, returnDetails: false, returnObjects: false }));
};
